module.exports = __webpack_public_path__ + "img/finance.62f6120d.svg";